// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"iY","modalBox":"iY","modal-mask":"iZ","modalMask":"iZ","close-btn":"i0","closeBtn":"i0","container":"i1","content":"i2","title":"i3","subTitle":"i4","detail":"i5"};